import React from 'react';

import PropTypes from 'prop-types';

import { currencyPropType } from 'helpers/customPropTypes';

import { DropdownList, DropdownListHeader, DropdownListItem } from './styles';
import { PromoText } from '../../no-auth/common/promo-text/PromoText';

const PromoCurrencyList = (props) => {
    const getCurrency = (country, currency) => {
        return (
            <DropdownListItem
                key={currency.code}
                onClick={(e) => props.onClickHandler(e, country, currency, true)}
                onKeyPress={(e) => props.onClickHandler(e, country, currency, true)}
                tabIndex={'0'}
            >
                <PromoText variant="subheader" color="gray80">
                    {currency.name}
                </PromoText>
                <PromoText variant="subheader" color="gray40">
                    {currency.code}
                </PromoText>
            </DropdownListItem>
        );
    };
    return (
        <DropdownList>
            <DropdownListHeader>
                <PromoText color="gray40">{props.header}</PromoText>
            </DropdownListHeader>
            {props.country && props.country.currencies && props.country.currencies.map((currency) => getCurrency(props.country, currency))}
        </DropdownList>
    );
};

PromoCurrencyList.propTypes = {
    onClickHandler: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    currencies: PropTypes.arrayOf(currencyPropType),
};
export default PromoCurrencyList;
